import CallOutcomeCardComponent from './CallOutcomeCard.component';

export * from "./CallOutcomeCard.component";
export default CallOutcomeCardComponent;
